import { ApiNetworkError, api } from '../api';
import type { User } from './AuthContext';

export type LoginResponse = {
  token: string;
  user: User;
  accountCreated: boolean;
};

function shouldRetry(error: unknown): boolean {
  const status =
    error && typeof error === 'object' && 'status' in error
      ? (error as { status?: unknown }).status
      : undefined;

  return error instanceof ApiNetworkError
    || status === 502
    || status === 503
    || status === 504;
}

export async function exchangeGoogleCredential(
  credential: string,
  request: typeof api = api,
  signal?: AbortSignal,
): Promise<LoginResponse> {
  let activeCredential: string | undefined = credential;
  const requestOptions: RequestInit = {
    method: 'POST',
    body: undefined,
    signal,
  };

  try {
    for (let attempt = 0; attempt < 2; attempt += 1) {
      requestOptions.body = JSON.stringify({ credential: activeCredential });
      try {
        return await request<LoginResponse>('/api/auth/google', requestOptions);
      } catch (error) {
        if (signal?.aborted) {
          throw error;
        }
        if (attempt === 0 && shouldRetry(error)) {
          continue;
        }
        throw error;
      }
    }

    throw new Error('Google sign-in retry invariant failed.');
  } finally {
    activeCredential = undefined;
    requestOptions.body = undefined;
  }
}
